module.exports = __webpack_public_path__ + "img/multiplataforma-new.e7bd65d1.png";